import { ALL_TOPICS } from './topicGroups';

const COMPANY_POOL = [
  'Google',
  'Amazon',
  'Microsoft',
  'Meta',
  'Apple',
  'Netflix',
  'Uber',
  'Adobe',
  'Salesforce',
  'Atlassian',
  'Bloomberg',
  'Oracle',
  'Nvidia',
  'LinkedIn',
  'PayPal',
  'Intuit',
];

const PROBLEM_VARIANTS = [
  'Core Interview Drill',
  'Edge Case Handling',
  'Optimized Approach',
  'Production Constraint Version',
  'Top Company Variant',
  'Follow-up Round Problem',
  'Onsite Simulation',
  'High Throughput Version',
  'Memory Optimized Version',
  'Master Challenge',
];

const difficultyByIndex = (index) => {
  if (index >= 8) return 'Hard';
  if (index >= 3) return 'Medium';
  return 'Easy';
};

export const pickTemplateForTopic = (topic) => {
  const value = topic.toLowerCase();
  if (value.includes('linked list')) return 'twoSum';
  if (value.includes('queue') || value.includes('stack') || value.includes('trie')) return 'stack';
  if (value.includes('tree') || value.includes('binary search tree')) return 'binarySearch';
  if (
    value.includes('graph')
    || value.includes('shortest path')
    || value.includes('topological')
    || value.includes('spanning tree')
    || value.includes('eulerian')
    || value.includes('connected component')
  ) return 'stack';
  if (
    value.includes('dynamic programming')
    || value.includes('memoization')
    || value.includes('game theory')
    || value.includes('combinatorics')
    || value.includes('probability')
  ) return 'dp';
  if (
    value.includes('sort')
    || value.includes('interval')
    || value.includes('divide and conquer')
    || value.includes('sweep line')
  ) return 'intervals';
  if (value.includes('binary search') || value.includes('segment tree') || value.includes('binary indexed tree')) return 'binarySearch';
  if (value.includes('window') || value.includes('two pointers') || value.includes('monotonic queue')) return 'slidingWindow';
  return 'twoSum';
};

export const inferVisualTypeFromPatterns = (patterns, fallbackVisualType) => {
  const joined = patterns.join(' ').toLowerCase();
  if (joined.includes('linked list') || joined.includes('doubly-linked list')) return 'linked-list';
  if (joined.includes('queue') || joined.includes('data stream')) return 'queue';
  if (
    joined.includes('graph')
    || joined.includes('shortest path')
    || joined.includes('topological sort')
    || joined.includes('minimum spanning tree')
    || joined.includes('eulerian circuit')
    || joined.includes('strongly connected component')
    || joined.includes('biconnected component')
  ) return 'graph';
  if (
    joined.includes('tree')
    || joined.includes('binary tree')
    || joined.includes('binary search tree')
    || joined.includes('trie')
  ) return 'tree';
  if (joined.includes('stack') || joined.includes('monotonic stack')) return 'stack';
  return fallbackVisualType;
};

export const generateTopicProblemSpecs = () => {
  const specs = [];
  ALL_TOPICS.forEach((topic, topicIndex) => {
    const companion = ALL_TOPICS[(topicIndex + 7) % ALL_TOPICS.length];
    for (let i = 0; i < 10; i += 1) {
      const title = `${topic} ${PROBLEM_VARIANTS[i]}`;
      const companies = [
        COMPANY_POOL[(topicIndex + i) % COMPANY_POOL.length],
        COMPANY_POOL[(topicIndex + i + 3) % COMPANY_POOL.length],
        COMPANY_POOL[(topicIndex + i + 8) % COMPANY_POOL.length],
      ];
      const patterns = i % 2 === 0 ? [topic] : [topic, companion];
      specs.push({
        title,
        difficulty: difficultyByIndex(i),
        companies,
        patterns,
        template: pickTemplateForTopic(topic),
      });
    }
  });

  return specs;
};

export const generateSpecsForTopics = (topics, globalOffset = 0) => {
  const topicSet = new Set(topics);
  return generateTopicProblemSpecs()
    .filter((spec) => spec.patterns.some((pattern) => topicSet.has(pattern)))
    .map((spec, index) => ({
      ...spec,
      title: `${spec.title}`,
      sortOrder: globalOffset + index,
    }));
};
